// @flow
import React, { Component, Fragment } from 'react';
import UserMenu from 'components/base/UserMenu';
import { connect } from 'react-redux';
import type { State } from 'store';
import { BaseActions, UserActions } from 'store/actionCreators';
import storage, { keys } from 'lib/storage';
import { resetSession } from 'lib/tracking';
import UserMobileMenu from 'components/base/UserMobileMenu';

type Props = {
  visible: boolean,
  username: string,
  rule: string,
  showDrawer?: boolean,
  depositHistoryCount: number,
};

class UserMenuContainer extends Component<Props> {
  onClickOutside = e => {
    BaseActions.hideUserMenu();
  };

  onClick = () => {
    BaseActions.hideUserMenu();
  };

  onLogout = async () => {
    // SSO 로그아웃 비활성화 - 기존 로그아웃 방식 사용

    // Tawk 로그아웃
    if (window.Tawk_API) {
      window.Tawk_API.logout();
    }

    // 추적 세션 리셋
    resetSession();

    // 로컬 스토리지 정리
    storage.remove(keys.user);

    // 백엔드 로그아웃 API 호출
    try {
      await UserActions.logout();
    } catch (e) {
      console.warn('Backend logout failed:', e);
    }

    // 홈페이지로 리다이렉트
    window.location.href = '/';
  };

  render() {
    const { visible, username, rule, depositHistoryCount } = this.props;
    const { onClickOutside, onClick, onLogout } = this;
    if (!visible) return null;

    return (
      <UserMenu
        username={username}
        rule={rule}
        hasDepositHistory={depositHistoryCount > 0}
        onClickOutside={onClickOutside}
        onClick={onClick}
        onLogout={onLogout}
        eventTypes={['click', 'touchend']}
      />
    );
  }
}

export default connect(
  ({ base, user, deposit }: State) => ({
    visible: base.userMenu,
    username: user.user && user.user.username,
    rule: user.user && user.user.rule,
    depositHistoryCount: deposit.historyCount || 0,
  }),
  () => ({}),
)(UserMenuContainer);



// WEBPACK FOOTER //
// ./src/containers/base/UserMenuContainer.js